import { NavLink } from "react-router-dom";
import { FolderKanban, Building2 } from "lucide-react";

/**
 * Small tab bar shared between /projects (route "/") and /clients.
 * Renders as two pill buttons that navigate on click. Uses NavLink so
 * the active state comes for free from react-router.
 */
export default function ProjectsClientsSwitch() {
  const base =
    "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-mono uppercase tracking-wider border rounded-sm transition-colors";
  const inactive = "border-zinc-800 text-zinc-500 hover:text-zinc-200 hover:border-zinc-700";
  const active = "border-amber-500/60 text-amber-300 bg-amber-500/10";
  return (
    <div
      className="inline-flex items-center gap-1"
      data-testid="projects-clients-switch"
    >
      <NavLink
        to="/"
        end
        data-testid="switch-projects"
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
      >
        <FolderKanban className="w-3 h-3" /> All Projects
      </NavLink>
      <NavLink
        to="/clients"
        data-testid="switch-clients"
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
      >
        <Building2 className="w-3 h-3" /> Clients
      </NavLink>
    </div>
  );
}
